var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.component.name)?_c(_vm.component.name,_vm._g(_vm._b({tag:"component"},'component',_vm.component.props,false),_vm.component.on ? { click: _vm.component.on.click } : {})):_vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }